/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_No_Chart_DataInputs */

const en_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available for the selected period`)
};

const fr_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée disponible pour la période sélectionnée`)
};

const de_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den ausgewählten Zeitraum sind keine Daten verfügbar.`)
};

const it_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato disponibile per il periodo selezionato`)
};

const ru_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные за выбранный период отсутствуют.`)
};

const es_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos disponibles para el período seleccionado`)
};

const zh_cn2_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选时间段内无可用数据。`)
};

const ja_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択した期間のデータはありません`)
};

const hi_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित अवधि के लिए कोई डेटा उपलब्ध नहीं है`)
};

const pt_pt2_usage_no_chart_data = /** @type {(inputs: Usage_No_Chart_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há dados disponíveis para o período selecionado.`)
};

/**
* | output |
* | --- |
* | "No data available for the selected period" |
*
* @param {Usage_No_Chart_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_no_chart_data = /** @type {((inputs?: Usage_No_Chart_DataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_No_Chart_DataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_no_chart_data(inputs)
	if (locale === "de") return de_usage_no_chart_data(inputs)
	if (locale === "it") return it_usage_no_chart_data(inputs)
	if (locale === "ru") return ru_usage_no_chart_data(inputs)
	if (locale === "es") return es_usage_no_chart_data(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_no_chart_data(inputs)
	if (locale === "ja") return ja_usage_no_chart_data(inputs)
	if (locale === "hi") return hi_usage_no_chart_data(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_no_chart_data(inputs)
	return en_usage_no_chart_data(inputs)
});